<template>
  <a-drawer width="55%" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="保证金主表ID" prop="bondId">
            <a-input-number v-model="form.bondId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付项ID" prop="bondItemId">
            <a-input-number v-model="form.bondItemId" style="width: 100%" :min="0" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="师傅订单ID" prop="masterOrderId">
            <a-input-number v-model="form.masterOrderId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="雇主订单ID" prop="customerOrderId">
            <a-input-number v-model="form.customerOrderId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="师傅用户ID" prop="masterUserId">
            <a-input-number v-model="form.masterUserId" style="width: 100%" :min="1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="流水号(空则后台生成)" prop="flowNo">
            <a-input v-model="form.flowNo" allow-clear placeholder="新增时可留空" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="流水类型" prop="flowType">
            <a-input-number v-model="form.flowType" style="width: 100%" :min="1" :max="9" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="业务类型" prop="bizType">
            <a-input-number v-model="form.bizType" style="width: 100%" :min="1" :max="7" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="业务单ID" prop="bizId">
            <a-input-number v-model="form.bizId" style="width: 100%" :min="0" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="渠道类型" prop="channelType">
            <a-input-number v-model="form.channelType" style="width: 100%" :min="1" :max="3" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="变动金额" prop="changeAmount">
            <a-input-number v-model="form.changeAmount" style="width: 100%" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="变动前金额" prop="beforeAmount">
            <a-input-number v-model="form.beforeAmount" style="width: 100%" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="变动后金额" prop="afterAmount">
            <a-input-number v-model="form.afterAmount" style="width: 100%" :step="0.01" :precision="2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="支付单号" prop="payOrderNo">
            <a-input v-model="form.payOrderNo" allow-clear />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="第三方交易号" prop="thirdTradeNo">
            <a-input v-model="form.thirdTradeNo" allow-clear />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="操作人ID" prop="operatorId">
            <a-input-number v-model="form.operatorId" style="width: 100%" :min="0" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="操作人类型" prop="operatorType">
            <a-input-number v-model="form.operatorType" style="width: 100%" :min="1" :max="4" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="操作时间" prop="operateTime">
            <a-date-picker
              v-model="form.operateTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="备注" prop="remark">
            <a-input v-model="form.remark" type="textarea" allow-clear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addOrderMasterBondFlow, getOrderMasterBondFlow, updateOrderMasterBondFlow } from '@/api/order/masterBondFlow'

function emptyForm() {
  return {
    id: null,
    bondId: null,
    bondItemId: null,
    masterOrderId: null,
    customerOrderId: null,
    masterUserId: null,
    flowNo: null,
    flowType: 1,
    bizType: 1,
    bizId: null,
    changeAmount: null,
    beforeAmount: null,
    afterAmount: null,
    channelType: null,
    payOrderNo: null,
    thirdTradeNo: null,
    operatorId: null,
    operatorType: null,
    operateTime: null,
    remark: null
  }
}

export default {
  name: 'OrderMasterBondFlowCreateForm',
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      form: emptyForm(),
      formType: 1,
      open: false,
      rules: {
        bondId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        masterOrderId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        customerOrderId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        masterUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        flowType: [{ required: true, message: '不能为空', trigger: 'blur' }],
        bizType: [{ required: true, message: '不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = emptyForm()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增保证金流水'
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      getOrderMasterBondFlow({ id: row.id }).then(response => {
        this.form = { ...emptyForm(), ...response.data }
        this.open = true
        this.formTitle = '编辑保证金流水'
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = { ...this.form }
        if (this.formType === 1) {
          delete payload.id
        }
        if (!payload.flowNo) {
          delete payload.flowNo
        }
        const submit = payload.id != null ? updateOrderMasterBondFlow(payload) : addOrderMasterBondFlow(payload)
        submit
          .then(() => {
            this.$message.success(payload.id != null ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>
